import { render } from "./SystemMicrosoftAuthentication.vue?vue&type=template&id=b279a510&ts=true"
import script from "./SystemMicrosoftAuthentication.vue?vue&type=script&lang=ts"
export * from "./SystemMicrosoftAuthentication.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__